/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceTenantSummary {
    getFixupPrototypeFunction() { return ComplianceTenantSummary.fixupPrototype; }

    static newInstance(model: Partial<ComplianceTenantSummary>): ComplianceTenantSummary {
        let obj = Object.assign(new ComplianceTenantSummary(), model);
        ComplianceTenantSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceTenantSummary>): ComplianceTenantSummary {
        if (!model) return null;
        return ComplianceTenantSummary.newInstance(<ComplianceTenantSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceTenantSummary) {
        if (!obj) return;

        models.ComplianceTenantSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceTenantSummary): boolean {
        Object.setPrototypeOf(obj, ComplianceTenantSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.control_status) {
            for (let val of this.control_status) {
                models.ComplianceControls.fixupPrototype(val);
            }
        }
    }

    tenant_id: string;

    compliance_uri: string;

    /**
     * File name of the logo associated with the compliance standard.
     */
    logo: string;

    /**
     * Compliance control status details
     */
    control_status: Array<models.ComplianceControls>;

}
